import React, {Fragment, useState} from 'react';


const Call_Modal_Message = (props) => {




    return (
        <Fragment>
            <style jsx>{`

                .modal-call-box-content img {
                    width: 70px;
                    height: 70px;
                    border-radius: 100%;
                }

                .modal-call-box-content {
                    display: flex;
                    flex-direction: column;
                    align-content: center;
                    justify-content: center;
                    align-items: center;
                }


                .alert-box-call-pollice {
                  
                    display: block;
                    margin-top: 8px;
                    margin-bottom: 8px;
                    background-color: #FFF3CD;
                    padding: 18px;
                    font-weight: bold;
                    font-family: 'iran';
                    color: #9B5800;
                    text-align: justify;
                    line-height: 1.6;
                    border-radius: 8px;
                  
                }

                .btn-call-modal {
                    transition: background-color 0.3s ease;
                    background-color: #FF9828;
                    padding: 8px;
                    border-radius: 10px;
                    color: white;
                    font-family: 'iran';
                    padding-right: 13px;
                    padding-left: 14px;
                    display: block;
                    margin-top: 21px;
                    margin-bottom: 21px;
                }

                .btn-call-modal:hover {
                    background-color: #01a2d3;
                }

                .first_last_name_modal_call {
                    font-size: 19px;
                    display: block;
                    margin-top: 11px;
                    font-weight: bold;
                    font-family: 'iran';
                }

            `}</style>


            <div className={"modal-call-box-content"}>

                <img src={String(props.modal_info_get.profile_src_post)}/>


                <span className={"first_last_name_modal_call"}>{String(props.modal_info_get.first_name_post)  +  " " + String(props.modal_info_get.last_name_post) }</span>

                <a href={"tel:" + String(props.modal_info_get.profile_mobile_post)} className={"btn-call-modal"}>
                    تلفن تماس :   {String(props.modal_info_get.profile_mobile_post)}
                </a>

                <div className={"alert-box-call-pollice"}>
                    <div style={{
                        "display": "flex",
                        "flexDirection": "row",
                        "justifyContent": "flex-start",
                        "alignContent": "center",
                        "alignItems": "center"
                    }}>

                        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
                                fill="#9B5800"/>
                        </svg>
                        <span style={{"color":"#9b5800","fontFamily":"'iran'","fontSize":"15px","paddingRight":"5px","fontWeight":"bold"}}>هشدار پلیس!</span>
                    </div>
                  <span style={{"color":"#a26310","display":"block","marginTop":"9px","fontFamily":"'iran'","fontSize":"11px","lineHeight":"1.6"}}>
                        لطفا پیش از انجام معامله و هر نوع پرداخت وجه ، از صحت کالا یا خدمات ارائه شده، به صورت حضوری اطمینان
                    حاصل نمایید
                  </span>
                </div>

            </div>
        </Fragment>

    );
};

export default Call_Modal_Message;
